import { CashRequestMiddleware } from './types'

/**
 * Sent untranslated so the stored device name is locale-independent; clients listing devices
 * should localize it at render time.
 */
export const WEB_DEVICE_NAME = 'Browser'

export const deviceNameRequest: CashRequestMiddleware = request => {
  const headers = request.headers as Record<string, string>

  headers['X-Device-Name'] = WEB_DEVICE_NAME

  return request
}
